module.exports = __webpack_public_path__ + "img/lobby_waiting_room_created.500cd384.png";